import { useAssociateFeedbackContext } from '../../contexts/AssociateFeedbackProvider';
import { AssociateFeedback } from '../../types/feedbacks';

const AssociateFeedbackHolder = ({
  feedback,
}: {
  feedback: AssociateFeedback;
}) => {
  // integration of context hooks here
  const { setShowAssociateFeedbackModal, setAssociateFeedback } =
    useAssociateFeedbackContext();

  // handler function to handle modal showing declared here
  const modalShowingHandler = () => {
    setShowAssociateFeedbackModal(true);
    setAssociateFeedback(feedback);
  };

  // rendering associate feedback holder component here
  return (
    <div>
      <button
        onClick={modalShowingHandler}
        className='font-medium text-base-light-blue hover:opacity-70 active:scale-95 duration-300'
      >
        {feedback.associate_full_name}
      </button>
    </div>
  );
};

export default AssociateFeedbackHolder;
